// Words of the visitor header, its mobile drawer and the theme switch, so
// screen readers hear the page language, not English.
export const visitorHeaderCopy = {
  fr: {
    home: "Accueil Yodi Data Hub",
    primaryNav: "Navigation principale",
    mobileNav: "Navigation",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    menu: "Menu",
    toLight: "Passer en mode clair",
    toDark: "Passer en mode sombre",
    light: "Clair",
    dark: "Sombre",
    leaderboard: "Classement",
    howItWorks: "Comment ça marche",
    languages: "Langues",
    faq: "FAQ",
    others: "Autres liens",
    report: "Signaler un problème",
  },
  en: {
    home: "Yodi Data Hub home",
    primaryNav: "Main navigation",
    mobileNav: "Navigation",
    openMenu: "Open the menu",
    closeMenu: "Close the menu",
    menu: "Menu",
    toLight: "Switch to light mode",
    toDark: "Switch to dark mode",
    light: "Light",
    dark: "Dark",
    leaderboard: "Leaderboard",
    howItWorks: "How it works",
    languages: "Languages",
    faq: "FAQ",
    others: "Other links",
    report: "Report a problem",
  },
} as const;

export function visitorHeaderText(language: string) {
  return visitorHeaderCopy[language === "en" ? "en" : "fr"];
}
